import WrappedPasswordChangeMobileForm from './views/PasswordChangeMobileView';

export default WrappedPasswordChangeMobileForm;